import { pushToDataLayer } from './pushToDataLayer';

export const enum DataLayerFinanceCalculatorEvent {
  finance_calculator_switch_tab = 'finance_calculator_switch_tab',
  edit_weekly_payment = 'edit_weekly_payment',
  edit_deposit_amount = 'edit_deposit_amount',
  edit_term_of_loan = 'edit_term_of_loan',
  edit_interest_rate = 'edit_interest_rate',
  edit_purchase_price = 'edit_purchase_price',
}
type FinanceCalculatorTab = 'WHAT_CAN_I_AFFORD' | 'MY_REPAYMENTS';

export type DataLayerFinanceCalculatorPayload = {
  tab: FinanceCalculatorTab;
  value?: any;
};

export const pushToDataLayerFinanceCalculator = (
  event: DataLayerFinanceCalculatorEvent,
  data?: Partial<DataLayerFinanceCalculatorPayload>,
) => {
  pushToDataLayer({
    event,
    value: {
      ...data,
      date: new Date().toISOString(),
    },
  });
};
export type EventInfo = {
  variant?: string;
  name?: string;
  value?: string;
  event: string;
  component?: string;
  type?: string;
};
